import React from 'react';
import moment from 'moment';
import NOTIFICATION_ICONS from '../constants/notificationIcons';
import TOAST_ICONS from '@shared/constants/toastIcons';
import { NotificationMessage } from '../../shared/components/NotificationMessage';

const ICON_VALUE_ICON_NAME_MAP = {
  [NOTIFICATION_ICONS.SUCCESS]: TOAST_ICONS.success,
  [NOTIFICATION_ICONS.INFO]: TOAST_ICONS.info,
  [NOTIFICATION_ICONS.WARNING]: TOAST_ICONS.warning,
  [NOTIFICATION_ICONS.ERROR]: TOAST_ICONS.error
};

const NotificationMapper = {
  mapNotification: userNotification => {
    return {
      id: userNotification.Notification.Id,
      type: userNotification.Notification.Type,
      content: (
        <NotificationMessage
          notificationType={userNotification.Notification.Type}
          notificationData={JSON.parse(userNotification.Notification.NotificationData)}
        />
      ),
      createdAt: moment(userNotification.Notification.CreatedAt).valueOf(),
      icon: ICON_VALUE_ICON_NAME_MAP[userNotification.Notification.Icon],
      read: userNotification.Read
    };
  }
};

export default NotificationMapper;
